module.exports = __webpack_public_path__ + "f27572681857d69739d37c26749ec2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-rabbit-good-morning.png
// module id = 2062
// module chunks = 4